// extracted by mini-css-extract-plugin
export default {"icon":"Contato_icon__Qz9mP","email":"Contato_email__hbla4"};